module.exports = __webpack_public_path__ + "media/images/crm/main-illustration-mobile-c982b0ce201c7cfdc1e080bfcdd3ff24.png";